import { ValidationStatus } from './invoice-scan-status';

export const validationTransitions: Record<ValidationStatus, ValidationStatus[]> = {
  pending: ['valid', 'invalid', 'partial_match', 'order_mismatch'],
  valid: [],
  invalid: ['pending'],
  partial_match: ['valid', 'invalid'],
  order_mismatch: ['valid', 'invalid'],
};

export const getAvailableTransitions = (currentStatus: string): ValidationStatus[] => {
  return validationTransitions[currentStatus as ValidationStatus] || [];
};
